export default "__VITE_PUBLIC_ASSET__70c40642__"